import { useQuery } from '@tanstack/react-query';
import { selfServiceClient } from '../services/selfService';
import { Metrics } from '../services/types';

export const defaultMetrics: Metrics = {
  balance: 0,
  contractedMrr: 0,
  creditBalance: 0,
  totalDebitMemoBalance: 0,
  totalInvoiceBalance: 0,
  unappliedCreditMemoAmount: 0,
  unappliedPaymentAmount: 0,
};

export const useMetricsQuery = () => {
  const { data = defaultMetrics, ...other } = useQuery({
    queryKey: ['metrics'],
    queryFn: selfServiceClient.getSubscriptionManagerMetrics,
    retry: false,
    refetchOnWindowFocus: false,
  });
  const outstandingBalance = data.totalInvoiceBalance + data.totalDebitMemoBalance;
  const unappliedBalance = data.unappliedPaymentAmount + data.unappliedCreditMemoAmount;
  return { outstandingBalance, unappliedBalance, ...data, ...other };
};
